import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { SWReactTable } from "app/components/React/Table/SWReactTable";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Wrapper = styled(FlexRow)`
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
`;

export const LeftContent = styled.div`
    flex-grow: 1;
    max-width: 60%;
    padding-top: 16px;

    @media (min-width: 1440px) {
        max-width: 50%;
    }
`;

export const ChartContent = styled(FlexRow)`
    column-gap: 12px;
    padding: 0 16px 16px 12px;
`;

export const ChartWrapper = styled(FlexRow)`
    justify-content: center;
    align-items: center;
    padding-top: 8px;

    @media (min-width: 1920px) {
        width: 282px;
    }
`;

export const LoaderContainer = styled(FlexRow)`
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    width: 210px;
`;

export const TableWrapper = styled(FlexRow)`
    flex-grow: 1;
`;

export const Table = styled(SWReactTable)`
    .swTable {
        overflow-x: clip;
        max-width: 100%;
    }

    & .swReactTableHeaderCell {
        background: ${colorsPalettes.carbon[0]};
        border: none;
    }

    & .swTable-headerCell {
        border-bottom: none;
        border-top: none;
    }
    & .swReactTableCell {
        box-sizing: border-box;
        height: 32px;
        padding: 9px;
        border-bottom: none;
        border-top: none;
    }
    & .changePercentage {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    & .index-cell-header {
        display: flex;
        justify-content: center;

        & > div {
            justify-content: center;
        }
    }
    & .default-empty-centered {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    & .default-centered {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    & .cell-innerText {
        max-width: 120px;
    }
`;

export const MetricsContainer = styled(FlexRow)`
    justify-content: flex-end;
    align-items: stretch;
    gap: 8px;
    padding: 8px;
    width: 40%;
    max-height: 224px;

    & > .changeWrapper,
    > .changeWrapperLoader {
        width: 50%;
        min-width: 183px;
        height: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        & div {
            padding: 0;
        }
    }

    @media (min-width: 1440px) {
        width: 50%;
    }
`;
